export const ADMIN = "ADMIN";
export const USER = "USER";


export const getAccessLevelName = (accessLevel) => {
    switch (accessLevel) {
        case ADMIN:
            return "Admin";
        case USER:
            return "User";
        default:
            return "";
    }
}
